export const FIRM_DOCUMENTS_WORKSPACE_TAB_SLUGS = {
  DOCUMENTS: 'documents',
  REQUESTS: 'requests',
} as const;

export const FIRM_DOCUMENTS_WORKSPACE_DEFAULT_TAB =
  FIRM_DOCUMENTS_WORKSPACE_TAB_SLUGS.DOCUMENTS;

export const FIRM_DOCUMENTS_WORKSPACE_LABELS = {
  documents: 'Documents',
  requests: 'Requests',
  secondaryNavigationAriaLabel: 'Documents secondary navigation',
} as const;
